import type { PropsWithChildren } from 'react';

import {
  ReactNativeLDClient,
  AutoEnvAttributes,
  LDProvider as LDProviderMobile,
} from '@launchdarkly/react-native-client-sdk';

const LaunchDarklyMobileProvider = ({ children }: PropsWithChildren) => {
  const client = new ReactNativeLDClient(
    // eslint-disable-next-line dot-notation
    process.env['LAUNCHDARKLY_MOBILE_KEY'] ?? '',
    AutoEnvAttributes.Enabled,
  );

  return <LDProviderMobile client={client}>{children}</LDProviderMobile>;
};

export { LaunchDarklyMobileProvider };
